import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageComponent } from './page.component';
import { PageRoutingModule } from './page-routing.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  imports: [PageRoutingModule, CommonModule, SharedModule, ReactiveFormsModule, MatSelectModule],
  declarations: [PageComponent],
  exports: [PageComponent]
})
export class PageModule { }
